let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hWBLl"), load("01FrO")]).then(() => parcelRequire('9LjTt'));